var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prd-navigation"},[_c('v-list',{attrs:{"dense":"","nav":""}},[(_vm.$isUrlScope('/admin'))?_c('the-admin-nav'):_vm._e(),(_vm.$isUrlScope('/trainer'))?_c('the-courses-nav'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }